import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ChatbotLogo from "../../../Components/images/original-17040e345a86ae1b2daee8562a215b9b.png"; 

export default function PortfolioChatbot() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const tenMinutes = 10 * 60 * 1000;

    useEffect(() => {
      const interval = setInterval(() => {
        fetch("https://my-app-qa1f.onrender.com/").catch(() => {
          console.log("Ping failed (server might be restarting)");
        });
      }, tenMinutes); // ping every 10 minutes

      return () => clearInterval(interval);
    }, []);

  const sendMessage = async () => {
    if (!input.trim()) return;
    const res = await fetch("https://my-app-qa1f.onrender.com/chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ question: input }),
    });
    const data = await res.json();
    setMessages((prev) => [
      ...prev,
      { role: "user", content: input },
      { role: "bot", content: data.answer },
    ]);
    setInput("");
  };

  return (
    <div className="fixed bottom-4 right-4">

      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-14 h-14 bg-blue-600 rounded-full flex items-center justify-center shadow-lg hover:scale-105 transition-transform"
      >
        <img src={ChatbotLogo} alt="Chatbot" className="w-12 h-12 rounded-full" />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 50 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 50 }}
            transition={{ duration: 0.3 }}
            className="fixed bottom-20 right-4 w-64 bg-white text-gray-700 rounded-lg shadow-xl p-2 flex flex-col mb-2"
          >
            <div className="max-h-64 overflow-y-auto">
              {messages.map((msg, i) => (
                <p
                  key={i}
                  className={msg.role === "user" ? "text-blue-500 text-right" : "text-gray-700 text-left"}
                >
                  {msg.content}
                </p>
              ))}
            </div>

            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
              className="border w-full p-2 rounded-md"
              placeholder="Ask me about Indra..."
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
